export default {
    appStatus: {
        message: 'Wczytywanie danych...',
        isError: false,
    },
    userId: null,
    manager: null,
    awardedDeviceIds: [],
    geofencesIds: [],
    isHighlightedDevicesView: false,
    focusDeviceId: null,
    selectedClassificationId: null,
    selectedSerieNumber: null,
    previousSelectedClassificationId: null,
    isLiveMode: true,
    playback: {},
    isPlaybackReady: false,
    playbackMarkers: {},
    socket: {
        isConnected: false,
        message: undefined,
        reconnectError: false,
    },
    isShowDistanceMarkers: true,
    amountDistanceMarkers: 5,
    listOrderBy: 'Nazwisko',
    isRevertDistanceMarkers: false,
    isShowAllNames: false,
    isShowDeviceTails: false,
    tracksBounds: {},
    markers: {},
    entities: {
        devices: {},
        devicesSummary: {},
        users: {},
        positions: {},
        trackpoints: {},
        competitions: {},
        gpxFiles: {},
        classifications: {},
        locations: {},
        players: {},
        competitionLayouts: {},
    },
    eventTimesData: {},
}
